import Vue from 'vue';
import state from '../state';
import noty from './noty.service';

export default {
  async getByClient(clientId, filter) {
    return (await Vue.http.post(`/api/players/byclient/${clientId}`, filter)).data;
  },
  async getStatsByClient(clientId) {
    return (await Vue.http.get(`/api/players/byclient/${clientId}/stats`)).data;
  },
  async load(playerId) {
    const editPlayer = state.editPlayer.get();
    playerId = playerId || (editPlayer ? editPlayer.id : false);
    if (!playerId) return null;
    const player = (await Vue.http.get(`/api/players/get/${playerId}`)).data;
    state.editPlayer.set(player);
  },
  async create(player) {
    let p = (await Vue.http.post('/api/players/create', player)).data;
    noty.success('Player created successfully');
    return p;
  },
  async checkUsername(username, clientId) {
    return (await Vue.http.post('/api/players/check/username', { username, clientId })).data;
  },
  async save(player) {
    let p = (await Vue.http.post('/api/players/save', player)).data;
    noty.success('Player saved successfully');
    return p;
  },
  async lock(playerId) {
    let p = (await Vue.http.post(`/api/players/lock/${playerId}`)).data;
    noty.success('Player locked successfully');
    return p;
  },
  async unlock(playerId) {
    let p = (await Vue.http.post(`/api/players/unlock/${playerId}`)).data;
    noty.success('Player unlocked successfully');
    return p;
  },
  async delete(playerId) {
    let p = (await Vue.http.delete(`/api/players/delete/${playerId}`)).data;
    noty.success('Player removed successfully');
    return p;
  },
  async changePassword(playerId, oldPassword, newPassword) {
    let res = (await Vue.http.post(`/api/players/changepassword/${playerId}`, { oldPassword, newPassword })).data;
    if (res.isSuccess) {
        noty.success('Player pasword changed successfully');
    } else {
        noty.error(`Error: ${res.error}`);
    }
    return res;
  },
  async resetPassword(playerId) {
    let res = (await Vue.http.post(`/api/players/resetpassword/${playerId}`)).data;
    noty.success('Player pasword changed successfully');
    return res;
  }
}



// WEBPACK FOOTER //
// ./src/services/player.service.js